import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from "@angular/core";
import { FormControl, Validators, FormGroup, FormBuilder } from "@angular/forms";
import { Usuario } from "../entidades/usuario";
import { ListasUsuario } from "../entidades/listas-usuario";
import { UsuarioService } from "../servicios/usuario.service";
import { Observable } from "rxjs";
import { startWith, map } from "rxjs/operators";
import { FuncionariosService } from "../servicios/funcionarios.service";
import Swal from "sweetalert2";

@Component({
  selector: "app-formulario-usuario",
  templateUrl: "./formulario-usuario.component.html",
  styleUrls: ["./formulario-usuario.component.css"]
})
export class FormularioUsuarioComponent implements OnInit, OnChanges {
  @Input() tipoFormulario: string;
  @Output() buscarUsuario = new EventEmitter<string>();

  listasUsuario: ListasUsuario = new ListasUsuario();
  usuario = new Usuario();
  is_active = false;

  posicionesFiltradas: Observable<string[]>;
  emailsJefesFiltrados: Observable<string[]>;

  formularioRegistro: FormGroup;
  controlEmail = new FormControl("", [Validators.required, Validators.email]);
  controlPosicion = new FormControl("", [Validators.required]);
  controlEmailJefes = new FormControl("", [Validators.required, Validators.email]);
  perfilSeleccionado;
  // metodo get para facil acceso a los campos del formulario
  get f() {
    return this.formularioRegistro.controls;
  }

  constructor(
    public funcionarioService: FuncionariosService,
    private formBuilder: FormBuilder,
    public usuarioService: UsuarioService
  ) {
    this.cargarListasAutocompletar(usuarioService);
  }

  cerrarFormulario() {
    this.buscarUsuario.emit("buscar");
  }

  cargarListasAutocompletar(usuarioService) {
    for (const lista in this.listasUsuario) {
      if (this.listasUsuario.hasOwnProperty(lista)) {
        usuarioService.obtenerLista(lista).subscribe(datos => {
          if (datos["status"] && datos["status"] === 200) {
            this.listasUsuario[lista] = datos["lista"];
          }
        });
      }
    }
  }

  ngOnInit() {


    this.formularioRegistro = this.formBuilder.group({
      nombre: ["", Validators.required],
      idioma: ["", Validators.required],
      numero_persona: ["", Validators.required],
      vicepresidencia: ["", Validators.required],
      pais: ["", Validators.required],
      lugar:["", Validators.required],
      direccion_gerencia:["", Validators.required],
      area:["", Validators.required],
      super_admin:["", Validators.required],
      estado:[false]
    });

    this.posicionesFiltradas = this.controlPosicion.valueChanges.pipe(
      startWith(""),
      map(value => this._filtro(value, "nombre_posicion"))
    );

    this.emailsJefesFiltrados = this.controlEmailJefes.valueChanges.pipe(
      startWith(""),
      map(value => this._filtro(value, "correo_corporativo_jefe"))
    );

   

    if (this.tipoFormulario == "Editar") {
      let idUsuario = localStorage.getItem("IdusuarioSapFrontera");
      this.funcionarioService.obtenerFuncionario(idUsuario).subscribe(datos => {
                
        if (datos["status"] && datos["status"] === 200) {
        
          this.usuario = datos["row"];
          this.is_active = datos["row"].estado == 'ACTIVO' ? true : false
         
          this.obtenerPerfil()
      //////conole.log(this.usuario)
        }

      });

      
     
    }
  }

  ngOnChanges() {
    this.usuario = new Usuario();
  }

  private _filtro(value: string, columna: string): string[] {
    const filterValue = value.toLowerCase();
    return this.listasUsuario[columna].filter(option => option.toLowerCase().includes(filterValue));
  }

  changeStatus(event) {
    var status_update = event
    if(!status_update){
      this.controlEmailJefes.disable()
      this.usuario.emailJefe = 'cumplimientonotificaciones@fronteraenergy.ca'
    }else{
      this.usuario.emailJefe = ''
      this.controlEmailJefes.enable()
    }
    this.usuario.estado = status_update ? "ACTIVO" : "INACTIVO";
  }

  crearUsuario() {
    if (this.validarCampos()) return;
    Swal.fire({
      title: "Crear usuario?",
      text: "",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Aceptar",
      cancelButtonText: "Denegar"
    }).then(result => {
      if (result.value) {
        if(this.perfilSeleccionado=="Admin"){
          this.usuario.super_admin=1
        }
        if(this.perfilSeleccionado=="Usuario final"){
          this.usuario.super_admin=0
        }
        if(this.perfilSeleccionado=="Auditor"){
          this.usuario.super_admin=2
        }
        this.usuarioService.crearUsuario(this.usuario).subscribe(datos => {
          //////conole.log(datos);
          if ((datos.status = 200)) {
            //////conole.log("ingresado ok");
            Swal.fire("Actualizado!", "Se creo el usuario", "success");
          }
        });
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire("Cancelado", "Se a cancelado la creacion del usuario", "error");
      }
    });
  }

  editarUsuario() {
    let idUsuario = localStorage.getItem("IdusuarioSapFrontera");
   // this.usuario.numeroPersonaFrontera = idUsuario;
    if (this.validarCampos()) return;
    Swal.fire({
      title: "Editar usuario?",
      text: "",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Aceptar",
      cancelButtonText: "Denegar"
    }).then(result => {
      if (result.value) {
        //////conole.log(this.usuario)
        if(this.perfilSeleccionado=="Admin"){
          this.usuario.super_admin=1
        }
        if(this.perfilSeleccionado=="Usuario final"){
          this.usuario.super_admin=0
        }
        if(this.perfilSeleccionado=="Auditor"){
          this.usuario.super_admin=2
        }
        this.usuarioService.editarUsuario(this.usuario).subscribe(datos => {
          //////conole.log(datos);
          if ((datos.status = 200)) {
            //////conole.log("ingresado ok");
            Swal.fire("Editar!", "Se edito el usuario", "success");
          }
        });
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire("Cancelado", "Se a cancelado la Edicion del usuario", "error");
      }
    });
  }

  validarCampos() {
    return (
      this.formularioRegistro.invalid ||
      this.controlEmailJefes.invalid ||
      this.controlPosicion.invalid ||
      this.controlEmail.invalid
    );
  }

  obtenerPerfil(){
    let idUsuario = localStorage.getItem("IdusuarioSapFrontera");
    this.funcionarioService.obtenerPerfil(idUsuario).subscribe(rt=>{
           
      this.usuario.super_admin=rt[0].super_admin
      if(this.usuario.super_admin==1){
        this.formularioRegistro.patchValue({
          super_admin:"Admin"
        })
      }

      if(this.usuario.super_admin==0){
        this.formularioRegistro.patchValue({
          super_admin:"Usuario final"
        })
      }

      if(this.usuario.super_admin==2){
        this.formularioRegistro.patchValue({
          super_admin:"Auditor"
        })
      }


      //////conole.log("SUPER_ADMIN",rt)
      
    })
  }


  seleccionarObjeto(e){
    this.perfilSeleccionado=e;
  }
}
